import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import CloseIcon from 'static/images/chat/closeChat.svg';
import MinimizeIcon from 'static/images/chat/minimizeChat.svg';
import MaximizeIcon from 'static/images/chat/maximizeChat.svg';
import { getResourceTo } from 'react/utils/utils';

function ChatHeader({ chat, toggleChatWindow, removeChatWindow }) {
  const chatName = useMemo(() => getResourceTo(chat.get('name')), [chat]);
  const userName = useMemo(() => chat.get('userName'), [chat]);

  return (
    <div className="header">
      <div className="titleContainer">
        <div className="info">
          <h4 className="title" title={chatName}>
            {chatName}
          </h4>
          <p className="user" title={userName}>
            {userName}
          </p>
        </div>
      </div>
      <div className="actions">
        <button
          className="minimizeBtn"
          type="button"
          onClick={() => toggleChatWindow({ chatId: chat.get('id') })}
        >
          <img src={chat.get('closed') ? MaximizeIcon : MinimizeIcon} alt="Close Icon" />
        </button>
        <button
          className="closeBtn"
          type="button"
          onClick={() => removeChatWindow({ chatId: chat.get('id') })}
        >
          <img src={CloseIcon} alt="Close Icon" />
        </button>
      </div>
    </div>
  );
}

ChatHeader.propTypes = {
  chat: PropTypes.object.isRequired,
  toggleChatWindow: PropTypes.func.isRequired,
  removeChatWindow: PropTypes.func.isRequired
};

export default ChatHeader;
